import { authorizedApiClient } from "./config";

export type MeetingNoteTakerPreference = {
    workspace_id: string;
    workspace_member_id?: string | null;
    provider: string;
    enabled: boolean;
    min_meeting_duration_minutes?: number | null;
    allowed_sources?: string[]; // e.g. ["google_calendar", "zoom"]
    extra_options?: Record<string, any>;
};

export type MeetingNoteTakerPreferenceUpdate = Partial<MeetingNoteTakerPreference>;

export const getMeetingNoteTakerPreference = async ({
    workspace_id,
    workspace_member_id,
}: {
    workspace_id: string;
    workspace_member_id?: string | null;
}) => authorizedApiClient.get(
    `/meeting-note-taker/${workspace_id}/preferences/meeting-note-taker`,
    {
        params: {
            workspace_member_id,
        },
    }
);

export const upsertMeetingNoteTakerPreference = async ({
    workspace_id,
    workspace_member_id,
    data,
}: {
    workspace_id: string;
    workspace_member_id?: string | null;
    data: MeetingNoteTakerPreferenceUpdate;
}) => authorizedApiClient.put(
    `/meeting-note-taker/${workspace_id}/preferences/meeting-note-taker`,
    data,
    {
        params: {
            workspace_member_id,
        },
    }
);

export const deleteMeetingNoteTakerPreference = async ({
    workspace_id,
    workspace_member_id,
}: {
    workspace_id: string;
    workspace_member_id: string;
}) => authorizedApiClient.delete(
    `/meeting-note-taker/${workspace_id}/preferences/meeting-note-taker`,
    {
        params: {
            workspace_member_id,
        },
    }
);
